import { motion } from 'framer-motion'
import s from './onboarding.module.scss'
import classNames from 'classnames'
import { Button } from '@shared/ui/button/button'
import { useUpdateUserPreference } from '@widgets/onboarding/api/useUpdateUserPreference'
import { toast } from 'react-toastify'
import { IconCheck } from '@tabler/icons-react'
import {
	START_DAY_OPTIONS,
	START_TIME_OPTIONS,
	getStartWhenValue,
	parseStartWhenValue,
} from './lib/student-onboarding-options'
import { itemVariants, optionHover, optionTap, sectionVariants } from '@shared/lib/onboarding-motion'
import { useState } from 'react'


export const StartTime = ({ setCurrentStep, selectedByQuestion, setSelectedByQuestion }) => {
	const [selectedParts, setSelectedParts] = useState(() => {
		const parsed = parseStartWhenValue(selectedByQuestion)
		return { days: parsed.days, times: parsed.times }
	})
	const {mutate} = useUpdateUserPreference({
		onSuccess: () => {
			toast.success('Анкета сохранена')
			window.ym(96194074,'reachGoal','save-user-preferences-by-onboarding')
			setCurrentStep((prev) => prev + 1)
		}
	})

	const toggleDay = (day) => {
		setSelectedParts((prev) => {
			const nextDays = prev.days.includes(day)
				? prev.days.filter((d) => d !== day)
				: [...prev.days, day]
			const next = { ...prev, days: nextDays }

			setSelectedByQuestion((p) => ({
				...p,
				...(next.days.length && next.times.length ? getStartWhenValue(next) : {}),
			}))

			return next
		})
	}

	const toggleTime = (time) => {
		setSelectedParts((prev) => {
			const nextTimes = prev.times.includes(time)
				? prev.times.filter((t) => t !== time)
				: [...prev.times, time]
			const next = { ...prev, times: nextTimes }

			setSelectedByQuestion((p) => ({
				...p,
				...(next.days.length && next.times.length ? getStartWhenValue(next) : {}),
			}))

			return next
		})
	}

	const onSubmit = () => {
		const studentPreferences = {
			...selectedByQuestion,
			...getStartWhenValue(selectedParts),
		}

		setSelectedByQuestion(studentPreferences)
		mutate({student_preferences: studentPreferences})
	}

	return (
		<motion.div className={s.slideWrapper} variants={sectionVariants} initial="initial" animate="animate">
			<motion.div className={s.titleWrapper} variants={itemVariants}>
				<p className={s.title}>Когда удобно заниматься</p>
				<p className={s.subtitle}>Выбери день и время, чтобы мы могли лучше подстроить рекомендации</p>
			</motion.div>
			<motion.div className={s.goalsQuestions} variants={sectionVariants}>
				<motion.div className={s.questionBlock} variants={itemVariants}>
					<p className={s.questionTitle}>1. День недели</p>
					<div className={s.goalOptionsGrid}>
						{START_DAY_OPTIONS.map((option) => {
							const isActive = selectedParts.days.includes(option.value)

							return (
								<motion.button
									key={option.value}
									type="button"
									className={classNames(s.goalOptionCard, isActive && s.active)}
									onClick={() => toggleDay(option.value)}
									whileHover={optionHover}
									whileTap={optionTap}
								>
									<span className={classNames(s.goalOptionCheck, isActive && s.checked)}>
										{isActive ? <IconCheck size={14} stroke={3} /> : null}
									</span>
									<span className={s.goalOptionLabel}>{option.label}</span>
								</motion.button>
							)
						})}
					</div>
				</motion.div>
				<motion.div className={s.questionBlock} variants={itemVariants}>
					<p className={s.questionTitle}>2. Время дня</p>
					<div className={s.goalOptionsGrid}>
						{START_TIME_OPTIONS.map((option) => {
							const isActive = selectedParts.times.includes(option.value)

							return (
								<motion.button
									key={option.value}
									type="button"
									className={classNames(s.goalOptionCard, isActive && s.active)}
									onClick={() => toggleTime(option.value)}
									whileHover={optionHover}
									whileTap={optionTap}
								>
									<span className={classNames(s.goalOptionCheck, isActive && s.checked)}>
										{isActive ? <IconCheck size={14} stroke={3} /> : null}
									</span>
									<span className={s.goalOptionLabel}>{option.label}</span>
								</motion.button>
							)
						})}
					</div>
				</motion.div>
			</motion.div>
			<motion.div className={s.btns} variants={itemVariants}>
				<Button
					label="Назад"
					size="small"
					theme="secondary"
					className={s.button}
					onClick={() => setCurrentStep((prev) => prev - 1)}
				/>
				<Button
					label="Завершить"
					size="small"
					className={s.button}
					disabled={!selectedParts.days.length || !selectedParts.times.length}
					onClick={onSubmit}
				/>
			</motion.div>
		</motion.div>
	)
}
